import * as yup from 'yup';

const currencyRegex = /^\d{1,},\d{2}$/;

yup.addMethod(yup.string, 'currency', function () {
  return this.test('currency', function () {
    const { path, createError } = this;
    const field = document.getElementById(path);
    return new Promise((resolve, reject) => {
      if (field && currencyRegex.test(field.value)) {
        resolve(true);
      } else {
        reject(createError({ path, message: 'Invalid currency' }));
      }
    });
  });
});

yup.addMethod(yup.string, 'multiselect', function () {
  return this.test('multiselect', function () {
    const { path, createError } = this;
    const value = document.getElementsByClassName('multiselect-' + path)[0]
      .options.length;
    return new Promise((resolve, reject) => {
      if (value) {
        resolve(true);
      } else {
        reject(
          createError({ path, message: 'field is required', type: 'required' })
        );
      }
    });
  });
});

yup.addMethod(yup.string, 'minValue', function () {
  return this.test('minValue', function () {
    const { path, createError } = this;
    const field = document.getElementById(path);
    return new Promise((resolve, reject) => {
      if (field && parseInt(field.value.replace(/,/g, '')) > 0) {
        resolve(true);
      } else {
        reject(createError({ path, message: 'Invalid minValue', type: 'min' }));
      }
    });
  });
});

const schema = yup.object().shape({
  code: yup
    .string()
    .required()
    .trim(),
  name: yup
    .string()
    .required()
    .trim(),
  saleValue: yup
    .string()
    .required()
    .currency()
    .minValue(),
  maximumDiscount: yup
    .string()
    .currency()
    .required()
    .trim(),
  description: yup
    .string()
    .required()
    .trim(),
  categories: yup.string().multiselect()
});

export default schema;
